 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {commitMutation} from 'react-relay'








import handleAddNotifications from './handlers/handleAddNotifications'
import handleAddOrganization from './handlers/handleAddOrganization'

graphql`
  fragment SetOrgUserRoleMutation_organization on SetOrgUserRoleSuccess {
    organization {
      ...CompleteOrganizationFrag @relay(mask: false)
    }
    notificationsAdded {
      type
      ...PromoteToBillingLeader_notification @relay(mask: false)
      ...PaymentRejected_notification @relay(mask: false)
    }
    updatedOrgMember {
      user {
        id
      }
      role
    }
  }
`

const mutation = graphql`
  mutation SetOrgUserRoleMutation($orgId: ID!, $userId: ID!, $role: OrgUserRole) {
    setOrgUserRole(orgId: $orgId, userId: $userId, role: $role) {
      ... on ErrorPayload {
        error {
          message
        }
      }
      ...SetOrgUserRoleMutation_organization @relay(mask: false)
    }
  }
`

export const setOrgUserRoleAddedOrganizationOnNext


 = (payload, {atmosphere, history}) => {
  if (!payload || !payload.organization || !_optionalChain([payload, 'access', _ => _.notificationsAdded, 'optionalAccess', _2 => _2.length])) return
  const {id: orgId, name: orgName} = payload.organization
  atmosphere.eventEmitter.emit('addSnackbar', {
    key: `promotedToBillingLead:${orgId}`,
    autoDismiss: 10,
    message: `Congratulations! You’ve been promoted to billing leader for ${orgName}`,
    action: {
      label: 'Check it out!',
      callback: () => {
        history && history.push(`/me/organizations/${orgId}/members`)
      }
    }
  })
}

export const setOrgUserRoleAddedOrganizationUpdater

 = (payload, {atmosphere, store}) => {
  const {viewerId} = atmosphere
  const notificationsAdded = payload.getLinkedRecords('notificationsAdded')
  const notificationsExist = notificationsAdded.some((notification) =>
    notification.getValue('type')
  )
  if (!notificationsExist) return
  const promotedUserId = payload
    .getLinkedRecord('updatedOrgMember')
    .getLinkedRecord('user')
    .getValue('id')
  if (promotedUserId === viewerId) {
    const notificationsAdded = payload.getLinkedRecords('notificationsAdded')
    handleAddNotifications(notificationsAdded , store)

    const org = payload.getLinkedRecord('organization')
    handleAddOrganization(org, store)
  }
}

const SetOrgUserRoleMutation = (
  atmosphere,
  variables,
  {onError, onCompleted}
) => {
  return commitMutation(atmosphere, {
    mutation,
    variables,
    onCompleted,
    onError
  })
}

export default SetOrgUserRoleMutation
